import { generateItems } from 'domain/common';
import { Auction } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Auction', Auction);

export { actions, selectors, reducer };
